import script from "./weekly-updates-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./weekly-updates-dashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__